import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const CURRENT_USER_QUERY = gql`
  query CurrentUser {
    currentUser {
      id
      email
      fullName
      role
      disabled
      forcePasswordChange
      createdAt
      updatedAt
    }
  }
`;

export function useCurrentUser() {
  const { data, loading, error, refetch } = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: 'network-only',
  });

  return {
    user: (data as any)?.currentUser || null,
    loading,
    error,
    refetch,
    isAuthenticated: !!((data as any)?.currentUser),
  };
}
